import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import { Grid, Row, Col } from 'react-flexbox-grid';
import { connect } from 'react-redux';
import Logo from './common/Logo';
import HamburgerMenu from './common/HamburgerMenu';
import NavOverlay from './NavOverlay';
import SharedHero from './SharedHero';
import PurpleLogo from '../images/logos/nurelm-logo-purple.svg';
import PurpleMobileLogo from '../images/logos/nurelm-logo-horizontal-purple.svg';

export const SUBHEADER_INNOVATE_TEXT = 'What Shall We Innovate today?';
export const SUBHEADER_INNOVATE_TEXT_LINK = 'Start a Project';

const SubHeader = ({
  history, location, logoColor, mobileLogoColor, navigationOpen, glyphColor, heroOverrides
}) => {
  const [hasScrollClass, setHasScrollClass] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setHasScrollClass(window.scrollY >= 200)
    }
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [])
 

  let headerclass = 'sticky-header';
  if (hasScrollClass) headerclass = 'sticky-header scrolling-header';

  return (
    <header className="main-header sub-header">
      <nav className={headerclass}>
        <Grid>
          <Row between="xs">
            <Col xs={4} md={3}>
              <Logo
                logoColor={logoColor}
                mobileLogoColor={mobileLogoColor}
              />
            </Col>
            <Col xs={6} md={6} className="innovate-cta">
              <Link to="/contact-us"
                title="Start a Project"
                onClick={() => window.scrollTo(0,0)}
              >
                {SUBHEADER_INNOVATE_TEXT}&nbsp;<span>{SUBHEADER_INNOVATE_TEXT_LINK}</span>
              </Link>
            </Col>
            <Col xs={2} lg={3} className="mobile-btn-wrapper">
              <HamburgerMenu />
            </Col>
          </Row>
        </Grid>
        {navigationOpen && <NavOverlay glyphColor={glyphColor} />}
      </nav>
      <SharedHero
        history={history}
        location={location}
        heroOverrides={heroOverrides}
      />
    </header>
  );
};

const mapStateToProps = ({ sharedPieces }) => {
  const { navigationOpen } = sharedPieces;
  return {
    navigationOpen
  }
}

SubHeader.defaultProps = {
  mobileLogoColor: PurpleMobileLogo,
  logoColor: PurpleLogo
}

export default connect(mapStateToProps, {})(SubHeader);
